import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@/hooks/use-auth-compat';
import {
  fetchTeacherSettings,
  updateTeacherSettings,
  type TeacherNotificationPreferences,
} from '@/services/teacherSettingsService';

export function useTeacherSettings() {
  const auth = useAuth();
  const token = auth.user?.access_token ?? '';

  return useQuery({
    queryKey: ['teacherSettings'],
    queryFn: () => fetchTeacherSettings(token),
    enabled: !!token,
    staleTime: 5 * 60 * 1000,
  });
}

export function useUpdateTeacherSettings() {
  const auth = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (patch: Partial<TeacherNotificationPreferences>) => {
      const token = await auth.getToken();
      return updateTeacherSettings(token, patch);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['teacherSettings'] });
    },
  });
}
